import { concatStyleSets } from '@uifabric/merge-styles';
import { Toggle } from 'office-ui-fabric-react';
import React, { Component } from 'react';

export class EUIToggle extends Component {

    static defaultProps = {
        offText: "Non",
        onText: "Oui",
        required: false,
    };

    render = () => {

        const { required, styles } = this.props;
        let newProps = { ...this.props };
        if (required)
            newProps.styles = concatStyleSets(
                styles, // Autres styles éventuels
                { label: { selectors: { "&::after": { color: "rgb(168, 0, 0)", content: "' *'", paddingRight: "12px" } } } } // Astérisque si Toggle marquée comme obligatoire
            );

        return <Toggle {...newProps} />;

    };

};